import React, { Component } from 'react';
import { Modal, Checkbox, message } from 'antd';
import ExportUtil from '../../../../common/ExportUtil';
import API_URL from '../../../../common/url';

const DefaultTypes = {
    visitRange: false,
    visitPlan: false,
};

class ExportModal extends Component {
    state = {
        visible: false,
        types: {...DefaultTypes},
        searchParams:{},
    }

    show = (searchParams) => {
        this.setState({ visible: true, searchParams });
    }

    hide = () => {
        this.setState({
            visible: false,
            types: {...DefaultTypes}
        });
    }

    confirm = () => {
        const { types: { visitRange, visitPlan }, searchParams } = this.state;
        if(!(visitRange || visitPlan)){
            message.warning('请选择需要导出的内容');
            return;
        }
        if (visitRange) {
            ExportUtil.export({ ...searchParams }, null, API_URL.export.exportVisitType);
        }
        if (visitPlan) {
            ExportUtil.export({ ...searchParams }, null, API_URL.export.exportPlanVisitTypeGrouping);
        }
        this.hide();
    }

    handleChange = (e, key) => {
        const { types } = this.state;
        types[key] = e.target.checked;
        this.setState({ types });
    }

    render() {
        const { visible, types } = this.state;
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
            >
                <div className="cont-cont" style={{ padding: '30px 20px' }}>
                    <ul className="preview-list">
                        <li className="preview-item">
                            <div className="item checkBoxchildren" >
                                <div><Checkbox onChange={e => this.handleChange(e, 'visitRange')} checked={types['visitRange']} value="visitRange">访视周期计划</Checkbox></div>
                                <div><Checkbox onChange={e => this.handleChange(e, 'visitPlan')} checked={types['visitPlan']} value="visitPlan">计划访视参数</Checkbox></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}

export default ExportModal;


// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/components/ExportModal.js